import React, { useEffect } from 'react';
import { ensureTokenValidity } from '../auth/auth';

function OAuthCallback() {
      
  return (
    <div></div>
  );
}

export default OAuthCallback;
